/* yūgure V3 Kaki · comportements de la zone panier (module ES, chargé par les blocs/sections custom-k-panier-*).
   1. <k-panier-dates> : relance le calcul des dates de livraison (custom-kaki.js) à l'insertion et après chaque
      rafraîchissement de la section du panier (le morph d'Horizon vide les <span data-k-de>).
   2. Note de commande : enregistrée à la saisie (/cart/update.js).
   3. Tiroir : déplace la réassurance de sections/custom-k-panier-tiroir.liquid dans le tiroir natif (voir ce fichier). */

import { StandardEvents } from '@shopify/events';

/* 1. Dates de livraison */
if (!customElements.get('k-panier-dates')) {
  customElements.define('k-panier-dates', class extends HTMLElement {
    connectedCallback() {
      this.fill();
      this.obs = new MutationObserver(() => {
        if (this.querySelector('[data-k-de]:empty') || this.querySelector('[data-k-dates][hidden]')) this.fill();
      });
      this.obs.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    }
    disconnectedCallback() { this.obs?.disconnect(); }
    /* custom-kaki.js écoute shopify:section:load sur le document et recalcule les dates dans e.target */
    fill() { this.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); }
  });
}

/* 2. Note de commande */
document.addEventListener('change', (e) => {
  const champ = e.target.closest?.('[data-k-note]');
  if (!champ) return;
  fetch((window.Theme?.routes?.cart_update_url || '/cart/update') + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ note: champ.value }),
  }).catch(() => {});
});

/* 3. Tiroir panier : le tiroir natif (snippets/cart-drawer.liquid, vendor) n'a ni bloc ni emplacement. La section
   custom-k-panier-tiroir, posée une fois dans un groupe de sections (pied de page), émet deux <template> : « haut »
   (bandeau d'offre) et « bas » (réassurance). Ici on les clone dans le tiroir : le haut avant la liste des articles,
   le bas à la fin du récapitulatif. Le tiroir est re-rendu par Horizon à chaque changement du panier : un
   MutationObserver remet la réassurance en place, et la section est redemandée (Section Rendering API) après chaque
   modification du panier pour que le bandeau suive le nombre d'articles. Aucune modification des fichiers vendor. */
const SRC = 'template[data-k-tiroir]';
let frag = null; /* { haut: string, bas: string } */
const lire = (root) => {
  const t = root.querySelector(SRC);
  if (!t) return null;
  const c = t.content;
  return { id: t.dataset.sectionId, haut: c.querySelector('[data-k-tiroir-haut]')?.outerHTML || '', bas: c.querySelector('[data-k-tiroir-bas]')?.outerHTML || '' };
};
let pending = false;
function monter() {
  pending = false;
  if (!frag) return;
  const comp = document.querySelector('cart-drawer-component');
  if (!comp) return;
  const contenu = comp.querySelector('.cart-drawer__content');
  const resume = comp.querySelector('.cart-drawer__summary');
  const rempli = !!comp.querySelector('.cart-form');
  const poser = (cle, html, parent, avant) => { /* avant = vrai : en tête du parent */
    const sel = `[data-k-tiroir-${cle}]`;
    const ex = comp.querySelector(sel);
    if (!rempli || !parent || !html) { ex?.remove(); return; }
    if (ex && ex.dataset.v === frag.v) return;
    ex?.remove();
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    const el = tpl.content.firstElementChild;
    el.dataset.v = frag.v;
    if (avant) parent.insertBefore(el, parent.firstElementChild); else parent.append(el);
  };
  poser('haut', frag.haut, contenu, true);
  poser('bas', frag.bas, resume, null);
}
const planifier = () => { if (!pending) { pending = true; requestAnimationFrame(monter); } };

async function rafraichir() {
  if (!frag?.id) return;
  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${encodeURIComponent(frag.id)}`, { headers: { Accept: 'application/json' } });
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json[frag.id] || '', 'text/html');
    const neuf = lire(doc);
    if (neuf) { frag = { ...neuf, v: String(Date.now()) }; planifier(); }
  } catch (e) { /* on garde la version précédente */ }
}

function initTiroir() {
  const lu = lire(document);
  if (!lu) return;
  frag = { ...lu, v: 'init' };
  planifier();
  const comp = document.querySelector('cart-drawer-component');
  if (comp) new MutationObserver(planifier).observe(comp, { childList: true, subtree: true });
  /* après chaque modification du panier (ajout, quantité, suppression) */
  let t;
  const apres = (e) => {
    const fin = () => { clearTimeout(t); t = setTimeout(rafraichir, 150); };
    if (e?.promise?.then) e.promise.then(fin, fin); else fin();
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, apres);
  document.addEventListener('theme-drawer:open', () => { planifier(); });
}
if (!window.__kTiroir) {
  window.__kTiroir = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTiroir);
  else initTiroir();
}
